import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    TextField,
    Typography
} from "@mui/material";
import green from "@mui/material/colors/green";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import { ChestData } from ".";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface NewBundleSate {
    modalVisible: boolean;
    isLoaded: boolean;
    creatingChest: boolean;
    error: null | string;
    form: any;
}

interface NewBundleProps {
    buttonText?: string;
    refreshParent(): void;
    classes: any;
    closeRowMenu(): void;
    chest: ChestData;
}

class EditPackWrapped extends React.Component<NewBundleProps, NewBundleSate> {

    constructor(props) {
        super(props);
        // List with grid items
        this.state = {
            // Flags
            modalVisible: false,
            isLoaded: false,
            error: null,
            creatingChest: false,
            // Form data
            form: {
                pack_name: this.props.chest.pack_name,
                localization_title: this.props.chest.localization_title,
                localization_desc: this.props.chest.localization_desc,
            },
        };
    }

    showModal = () => this.setState({ modalVisible: true });
    handleModalCancel = () => {
        this.props.closeRowMenu();
        this.setState({ modalVisible: false, error: null, form: {} });
    }
    handleModalCreate = () => {
        this.setState({ creatingChest: true }, async () => {
            try {
                const result = await axios.put(`${Config.getInstance.apiUrl}/api/bounty/packs`, {
                    ...this.state.form,
                    pack_id: this.props.chest.pack_id,
                }, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                    },
                });

                this.props.closeRowMenu();

                this.setState({ creatingChest: false, modalVisible: false, form: {} }, () => {
                    this.props.refreshParent();
                });
            } catch (error) {
                PopupMessage.error("Something went wrong");
                this.setState({ creatingChest: false });
            }
        });
    }

    handleChange = name => event => {
        const formData = { ...this.state.form };
        formData[name] = event.target.value;

        if (name === "currency" && event.target.value === 99) {
            formData.price = 0;
        }

        this.setState({ form: formData });
    }

    render() {
        const { classes } = this.props;

        const dialogContent = () => <div>
            <TextField
                margin="normal"
                id="pack_name"
                label="Bounty pack name"
                fullWidth
                onChange={this.handleChange("pack_name")}
                value={this.state.form.pack_name || ""}
            />

            <Typography variant="h6" style={{ marginBottom: 0, marginTop: 15, color: "#919191" }}>
                Localization
            </Typography>

            <TextField
                margin="normal"
                id="localization_title"
                label="Title"
                fullWidth
                onChange={this.handleChange("localization_title")}
                value={this.state.form.localization_title || ""}
            />

            <TextField
                margin="normal"
                id="localization_desc"
                label="Description"
                fullWidth
                onChange={this.handleChange("localization_desc")}
                value={this.state.form.localization_desc || ""}
            />
        </div>;

        return (
            <div>
                <MenuItem onClick={this.showModal}>
                    Edit
                </MenuItem>

                <Dialog
                    open={this.state.modalVisible}
                    onClose={this.handleModalCancel}
                    aria-labelledby="form-dialog-title"
                    fullWidth={true}
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">
                        Edit {this.props.chest.pack_name}
                    </DialogTitle>
                    <DialogContent>
                        {dialogContent()}
                    </DialogContent>
                    <DialogActions>
                        <Button disableElevation onClick={this.handleModalCancel} disabled={this.state.creatingChest}>
                            Cancel
                        </Button>
                        <div className={classes.wrapper}>
                            <Button disableElevation
                                onClick={this.handleModalCreate}
                                color="primary"
                                disabled={this.state.creatingChest}
                            >
                                Edit
                            </Button>
                            {this.state.creatingChest && <CircularProgress size={24} className={classes.buttonProgress} />}
                        </div>

                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

const styles: any = theme => ({
    wrapper: {
        margin: 8,
        position: "relative",
    },
    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    }
});

export const EditPack = withStyles(styles)(EditPackWrapped);
